import React from "react";
import PayrollRomms from "../../payroll/PayrollRomms";

interface TrdRcvRommsProps {
  onBack: () => void;
}

export default function TrdRcvRomms({ onBack }: TrdRcvRommsProps) {
  return <PayrollRomms onBack={onBack} onComplete={() => {}} workspace="Trade Receivables" />;
}


